<template>
    <!-- pc端微信Native支付,JSAPI支付 -->
    <a-modal title="微信支付" :width="600" :open="true" @cancel="cancel" @ok="ok">
        <div style="text-align: center; display: flex; flex-direction: column; align-items: center; margin: 30px 0">
            <div>注意：①付款流水多少，开多少发票</div>
            <div>注意：②付款流水多少，开多少发票</div>
            <div>注意：③付款流水多少，开多少发票</div>
            <a-qrcode :status="state.qrcode?.length > 0 ? 'active' : 'loading'" :value="state.qrcode" :size="230"
                icon="/themes/images/weichatpay.svg"></a-qrcode>
            <div>
                <span style="color: red">￥{{ state.qrcode_money }}元</span> {{ props.qrcodeData.trade_type == 'Native' ?
                    '微信扫码付款(有效期2小时)' : '微信扫码或识别二维码付款' }}
            </div>
            <div>{{ state.full_name }}</div>
            <!-- 新增续费时长显示 - 仅当 public_payment_type == 2 时显示 -->
            <template v-if="props.qrcodeData.public_payment_type == 2">
                <div v-if="state.renewal_duration" style="margin-top: 8px; color: #666;">
                    续费时长：{{ state.renewal_duration }}
                </div>
                <div v-if="state.current_trust_time && state.renewal_duration"
                    style="margin-top: 4px; color: #666; font-size: 14px;">
                    当前托管时间：{{ state.current_trust_time }}
                </div>
                <div v-if="state.new_trust_time"
                    style="margin-top: 4px; color: #1890ff; font-size: 14px; font-weight: 500;">
                    续费后托管时间：{{ state.new_trust_time }}
                </div>
            </template>
        </div>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref, h, onUnmounted } from 'vue'
import dayjs from 'dayjs'

const emit = defineEmits(['cancel', 'ok'])

const props = defineProps({
    qrcodeData: {
        type: Object,
        default: {
            qrcode: '', //二维码url
            qrcode_money: 0, //金额
            payment_record_id: 0, //记录id
            full_name: '', //名称
            trade_type: '', //付款方式
            enter_starttime: '', //当前托管开始时间
            enter_endtime: '', //当前托管结束时间
            renewal_duration: '', //续费时长（如：1年、2年等）
            month_quantity: 0, //续费月份数
            fee_standard: 1, //续费类型：1按年续费，2一次性续费
            public_payment_type: 0 //支付类型：1注册费，2续费，3其他
        }
    }
})
const state = reactive<any>({
    qrcode: '',
    qrcode_money: 0,
    qrcodeInterval: null, //二维码状态定时查询
    full_name: '',
    trade_type: 'Native',
    current_trust_time: '',
    new_trust_time: '',
    renewal_duration: ''
})

onMounted(() => {
    //显示二维码并开启查询
    state.qrcode = props.qrcodeData.qrcode
    state.qrcode_money = props.qrcodeData.qrcode_money
    state.full_name = props.qrcodeData.full_name

    // 只有续费时才计算并显示续费时长信息
    if (props.qrcodeData.public_payment_type == 2) {
        calculateRenewalInfo()
    }

    //并不是所有的都可以查询，比如续费联系人只是进入入驻服务费页面
    if (props.qrcodeData.payment_record_id) {
        getQrcodeStatus()
    }
})

// 计算续费信息
const calculateRenewalInfo = () => {
    const { enter_starttime, enter_endtime, renewal_duration, month_quantity, fee_standard } = props.qrcodeData

    // 显示续费时长
    if (renewal_duration) {
        state.renewal_duration = renewal_duration
    } else if (month_quantity) {
        // 根据月份数显示时长
        if (month_quantity >= 12 && month_quantity % 12 === 0) {
            state.renewal_duration = `${month_quantity / 12}年`
        } else {
            state.renewal_duration = `${month_quantity}个月`
        }
    }

    // 显示当前托管时间
    if (enter_starttime && enter_endtime) {
        const start = enter_starttime.substring(0, 10)
        // 处理enter_endtime可能包含HTML标签的情况
        const endDiv = document.createElement('div')
        endDiv.innerHTML = enter_endtime
        const end = endDiv.textContent || endDiv.innerText || enter_endtime
        state.current_trust_time = `${start} ~ ${end}`

        // 计算续费后的时间
        if (month_quantity && enter_endtime) {
            // 获取纯文本的结束时间
            const endText = endDiv.textContent || endDiv.innerText || enter_endtime
            const endDate = dayjs(endText.trim())
            if (endDate.isValid()) {
                const newEndDate = endDate.add(month_quantity, 'month')
                state.new_trust_time = `${end} ~ ${newEndDate.format('YYYY-MM-DD')}`
            }
        }
    }
}

onUnmounted(() => {
    clearInterval(state.qrcodeInterval)
})

const getQrcodeStatus = () => {
    //开启支付成功的查询
    clearInterval(state.qrcodeInterval)
    state.qrcodeInterval = setInterval(() => {
        let requeryParam = {
            url: '/admin/v1/paymentRecordStatus?id=' + props.qrcodeData.payment_record_id,
            method: 'get'
        }
        baseService(requeryParam)
            .then((res: any) => {
                if (res.msg == 'success') {
                    clearInterval(state.qrcodeInterval)
                    message.success('微信付款成功!')
                    emit('ok')
                }
            })
            .catch((res) => { })
    }, 2000)
}

const cancel = () => {
    emit('cancel')
}

const ok = () => {
    emit('ok')
}
</script>
<style lang="scss" scoped></style>
